import React, { useState, useEffect, useCallback } from "react";
import debounce from "lodash.debounce";
import { useHistory, useLocation } from "react-router-dom";
import * as QueryString from 'query-string';
import Pagination from "web/components/Pagination";
import * as moment from "moment";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import DropDown from "web/components/DropDown";
import AlertModal from "web/components/AlertModal";
import Breadcrumb from "web/components/Breadcrumb";
import { fetchPickupOrders, fetchPickupOrderBaggageCountAPI, orderBaggageReadApi } from "redux/actions/myPickupOrders";

import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

import TabContents from "./TabContents";
import FilterIcon from "web/assets/images/filterIcon.png";
import FilterModal from "../PopUpModals/FilterModal";
import { Container, SearchSection, OrderTopHeader, SectionWrapper, Description, FilterWrapper } from "../orderStyled";
import { fetchLanguageContentNew } from "redux/actions/language";
import { downloadFile } from "redux/actions/helper/downloadFile";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "transparent",
  },
  indicator: {
    background: "#2fb5f1",
  },

  AppBar: {
    backgroundColor: "transparent",
    color: "#000000",
    boxShadow: "none",
  },
  Tab: {
    textTransform: "capitalize",
    fontSize: "16px",
  },
  hiddenTab: {
    display: 'none',
  },
}));

export default function OrderTabs() {
  const token = localStorage.getItem("token");
  const storedData = useSelector((state) => state.storedData.payload);
  const classes = useStyles();
  let history = useHistory();
  let location = useLocation();
  const dispatch = useDispatch();
  const queryParams = QueryString.parse(location.search);
  const tabLabels = ['Pending Pickup Requests', 'Scheduled Pickups', 'Finalized Pickups', 'Completed Orders', 'Canceled Orders', 'Claimed Orders', 'All Orders'];
  const tabPanels = ['pending', 'scheduled', 'pickedup', 'complete', 'canceled', 'claimed', 'all'];
  const [filterPopUpModal, setFilterPopUpModal] = useState(false);

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");

  const [value, setValue] = useState(0)
  const [currentPage, setCurrentPage] = useState(1);

  const [searchVal, setSearchVal] = useState('');
  const [pageData, setPageData] = useState();
  const [totalPages, setTotalPages] = useState(0)
  const [orderCounts, setOrderCounts] = useState()

  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const languageContentNew = useSelector((state) => state.language.languageContentNew);
  const [pageLanguageContents, setPageLanguageContents] = useState();
  const dropDownArr = [
    { id: "0", label: "Oldest Requested Date", value: "ASC", },
    { id: "1", label: "Newest Requested Date", value: "DESC", },
  ]
  const [sortByValue, setSortByValue] = useState("ASC");

  let defaultFilterModalValues = {
    orderStatus: [{ label: "Pending", value: "PENDING" }],
    fromDateOrderFilter: moment().subtract(31, 'days').format('MM/DD/YYYY'),
    toDateOrderFilter: moment().add(31, 'days').format('MM/DD/YYYY')
  }
  const [filterModalValues, setFilterModalValues] = useState(defaultFilterModalValues)

  useEffect(() => {
    if (languageContentNew?.My_Orders_Page) setPageLanguageContents(languageContentNew.My_Orders_Page)
    else dispatch(fetchLanguageContentNew(currentLanguage));
  }, [languageContentNew]);

  useEffect(() => {
    fetchOrderBaggageCount()
    let isRedirectFromSomePage, hideFirstTab

    //for user without access to buyback feature, first tab is hidden, so setting to schedule tab by default
    if (!storedData?.data?.isEnablePickupFeature) hideFirstTab = true

    if (queryParams?.ordertab === 'scheduled') isRedirectFromSomePage = 1
    else if (queryParams?.ordertab === 'claim') isRedirectFromSomePage = 5
    else if (localStorage.getItem('redirectPickupOrderTabValue')) isRedirectFromSomePage = localStorage.getItem('redirectPickupOrderTabValue')
    else if (hideFirstTab) isRedirectFromSomePage = 1

    const redirectedsSearchByOrderValue = localStorage.getItem('redirectedOrderValue');

    if (isRedirectFromSomePage) {
      let orderStatusValue
      let newValue = parseInt(isRedirectFromSomePage)
      if (newValue === 0) orderStatusValue = [{ label: "Pending", value: "PENDING" }]
      else if (newValue === 1) orderStatusValue = [{ label: "Assigned", value: "ASSIGNED" }, { label: "Rescheduled", value: "RESCHEDULED" }]
      else if (newValue === 2) orderStatusValue = [{ label: "Picked Up", value: "PICKEDUP" }, { label: "Hold", value: "HOLD" }]
      else if (newValue === 3) orderStatusValue = [{ label: "Completed", value: "COMPLETE" }]
      else if (newValue === 4) orderStatusValue = [{ label: "Canceled", value: "CANCELLED" }]
      else if (newValue === 5) orderStatusValue = [{ label: "Claimed", value: "CLAIM" }]
      else if (newValue === 6) {
        orderStatusValue = [{ label: "Assigned", value: "ASSIGNED" },
        { label: "Rescheduled", value: "RESCHEDULED" },
        { label: "Picked up", value: "PICKEDUP" },
        { label: "Hold", value: "HOLD" },
        { label: "Completed", value: "COMPLETE" },
        { label: "Canceled", value: "CANCELLED" },
        { label: "Claimed", value: "CLAIM" }]
      }
      let oldFilterValues = filterModalValues
      let updatedFilterValues = {
        ...oldFilterValues,
        orderStatus: orderStatusValue
      }
      setFilterModalValues(updatedFilterValues)
      setValue(newValue)

      let searchByValue = searchVal
      if (redirectedsSearchByOrderValue) {
        searchByValue = redirectedsSearchByOrderValue
        setSearchVal(searchByValue)
      }

      fetchPageDataFunction(newValue, undefined, { filterValues: updatedFilterValues, searchValue: searchByValue })
    } else fetchPageDataFunction()
  }, []);

  // tabType is the current selected tab
  // data is whole api data
  // dynamicUpdatedValue can be either sortValue, currentPage, filterModalValues, searchVal
  const fetchPageDataFunction = async (tabType, data, dynamicUpdatedValue) => {
    fetchOrderBaggageCount()
    let authID = localStorage.getItem('authId')
    let selectedTab = tabType ?? value
    let filterValues = dynamicUpdatedValue?.filterValues || filterModalValues
    let currentPageValue = dynamicUpdatedValue?.currentPage ?? currentPage
    let sortValue = dynamicUpdatedValue?.sortValue || sortByValue
    let searchValue = dynamicUpdatedValue?.searchValue ?? searchVal
    let apiUrl, currentOrderTabValue, orderStatusList
    // set url (one for pending, common for other tabs)
    if (selectedTab === 0) apiUrl = '/order/pickup/get_pending_list'
    else apiUrl = '/order/v2/pickup/get_order_list'
    // set orderstatus and current order tab enums
    let listOfTabs = ['PENDING', 'SCHEDULED', 'PICKEDUP', 'COMPLETE', 'CANCELLED', 'CLAIMED', 'ALL']
    currentOrderTabValue = listOfTabs[selectedTab] || 'PENDING'
    orderStatusList = filterValues.orderStatus?.map(data => data.value) || null
    let apiData
    if (data) apiData = data
    else {
      apiData = {
        authId: authID,
        locationId: localStorage.getItem('locationId'),
        size: 10,
        number: currentPageValue > 1 ? currentPageValue - 1 : 0,
        sort: sortValue,
        currentOrderTab: selectedTab === 0 ? null : currentOrderTabValue,
        searchCriteria: {
          searchBy: searchValue?.trim(),
          fromDate: searchValue?.trim() ? null : moment(filterValues.fromDateOrderFilter).format('YYYY/MM/DD'),
          toDate: searchValue?.trim() ? null : moment(filterValues.toDateOrderFilter).format('YYYY/MM/DD'),
          orderStatus: orderStatusList
        }
      }
    }
    let response
    response = await dispatch(fetchPickupOrders(apiUrl, apiData, token, authID));
    localStorage.removeItem('redirectPickupOrderTabValue')
    localStorage.removeItem('redirectedOrderValue')
    if (response?.success) {
      setPageData(response?.data?.orderList || response?.data?.pickupOrderList)
      setTotalPages(response?.data?.totalElements)
      orderBaggageReadFunction(selectedTab)
    } else {
      setTotalPages(0)
      if (response.statusCode === 401) {
        history.push('./sign-in')
      } else {
        setModalContent(response?.data?.data?.message || response?.data?.error?.message || response.message || 'Someting went wrong, please try again in some time.')
        setModal(!modal)
      }
    }
  }

  const fetchOrderBaggageCount = async () => {
    let data = {
      authId: localStorage.getItem('authId')
    }
    let response = await dispatch(fetchPickupOrderBaggageCountAPI(data, token))
    if (response?.success) setOrderCounts(response.data)
    else setOrderCounts()
  }

  const orderBaggageReadFunction = async (tab) => {
    let tabList = ['OPEN', 'SCHEDULED', 'PICKEDUP', 'COMPLETE', 'CANCELLED', 'CLAIMED']
    let response
    if (tab < 6) response = await dispatch(orderBaggageReadApi(tabList[tab || 0], token))
    if (response?.status === "SUCCESS") fetchOrderBaggageCount()
  }

  const onPageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    fetchPageDataFunction(undefined, undefined, { currentPage: pageNumber })
  }

  const handleSearchFunction = (event) => {
    setCurrentPage(1)
    let searchValue = event.target.value
    setSearchVal(searchValue)
    let currentOrderTabValue, orderStatusList
    let listOfTabs = ['PENDING', 'SCHEDULED', 'PICKEDUP', 'COMPLETE', 'CANCELLED', 'CLAIMED', 'ALL']
    currentOrderTabValue = listOfTabs[value] || 'PENDING'
    orderStatusList = filterModalValues.orderStatus?.map(data => data.value) || null
    let data = {
      authId: localStorage.getItem('authId'),
      locationId: localStorage.getItem('locationId'),
      size: 10,
      number: 0,
      sort: sortByValue,
      currentOrderTab: value === 0 ? null : currentOrderTabValue,
      searchCriteria: {
        searchBy: searchValue?.trim(),
        fromDate: searchValue?.trim() ? null : moment(filterModalValues.fromDateOrderFilter).format('YYYY/MM/DD'),
        toDate: searchValue?.trim() ? null : moment(filterModalValues.toDateOrderFilter).format('YYYY/MM/DD'),
        orderStatus: orderStatusList
      }
    }
    let tabValue = value
    debouncedSearch(data, tabValue);
  }

  const debouncedSearch = useCallback(debounce((data, tabValue) => fetchPageDataFunction(tabValue, data), 500), []);

  let breadcrumbMapArr = [
    {
      name: pageLanguageContents?.Breadcrumb[0]?.Home,
      link: "/dashboard",
      eventType: "Link",
    },
  ];

  const switchTabAndFetchData = (tabValue) => {
    let newTab = parseInt(tabValue)
    let orderStatusValue
    if (newTab === 0) orderStatusValue = [{ label: "Pending", value: "PENDING" }]
    else if (newTab === 1) orderStatusValue = [{ label: "Assigned", value: "ASSIGNED" }, { label: "Rescheduled", value: "RESCHEDULED" }]
    else if (newTab === 2) orderStatusValue = [{ label: "Picked Up", value: "PICKEDUP" }, { label: "Hold", value: "HOLD" }]
    else if (newTab === 3) orderStatusValue = [{ label: "Completed", value: "COMPLETE" }]
    else if (newTab === 4) orderStatusValue = [{ label: "Canceled", value: "CANCELLED" }]
    else if (newTab === 5) orderStatusValue = [{ label: "Claimed", value: "CLAIM" }]
    else if (newTab === 6) {
      orderStatusValue = [{ label: "Assigned", value: "ASSIGNED" },
      { label: "Rescheduled", value: "RESCHEDULED" },
      { label: "Picked up", value: "PICKEDUP" },
      { label: "Hold", value: "HOLD" },
      { label: "Completed", value: "COMPLETE" },
      { label: "Canceled", value: "CANCELLED" },
      { label: "Claimed", value: "CLAIM" }]
    }
    let oldFilterValues = filterModalValues
    let updatedFilterValues = {
      ...oldFilterValues,
      orderStatus: orderStatusValue
    }
    setFilterModalValues(updatedFilterValues)
    setTotalPages(0)
    setPageData()
    setValue(newTab);
    setCurrentPage(1);
    setSearchVal('');
    setSortByValue(newTab === 6 ? 'DESC' : 'ASC');
    fetchPageDataFunction(newTab, undefined, { filterValues: updatedFilterValues, sortValue: newTab === 6 ? 'DESC' : 'ASC', currentPage: 1, searchValue: '' })
  }

  const showOrderCountFunction = (index) => {
    if (orderCounts) {
      if (index === 0 && orderCounts?.openOrderCount) return <span className="order-count-class">{orderCounts?.openOrderCount}</span>
      if (index === 1 && orderCounts?.scheduledOrderCount) return <span className="order-count-class">{orderCounts?.scheduledOrderCount}</span>
      if (index === 2 && orderCounts?.pickedupOrderCount) return <span className="order-count-class">{orderCounts?.pickedupOrderCount}</span>
      if (index === 3 && orderCounts?.completedOrderCount) return <span className="order-count-class">{orderCounts?.completedOrderCount}</span>
      if (index === 4 && orderCounts?.cancelledOrderCount) return <span className="order-count-class">{orderCounts?.cancelledOrderCount}</span>
      if (index === 5 && orderCounts?.claimedOrderCount) return <span className="order-count-class">{orderCounts?.claimedOrderCount}</span>
      if (index === 6 && orderCounts?.totalOrderCount) return <span className="order-count-class">{orderCounts?.totalOrderCount}</span>
    }
  }

  return (
    <section>
      <Container>
        <div className={classes.root}>
          <Breadcrumb
            breadcrumbArr={breadcrumbMapArr}
            selected='My Pickup Orders'
            title=""
          />
          <SectionWrapper>
            <div className={styled.textSection}>
              <OrderTopHeader>
                <DropDown
                  name="dropDown"
                  data={dropDownArr}
                  searchDropDown={sortByValue}
                  placeholder={pageLanguageContents?.HeaderContents[0]?.SortBy}
                  onChangeHandler={(event) => {
                    setCurrentPage(1)
                    setSortByValue(event.value);
                    fetchPageDataFunction(undefined, undefined, { sortValue: event.value, currentPage: 1 })
                  }}
                />
                <div style={{ display: 'flex' }}>
                  <SearchSection>
                    <input placeholder="Search" value={searchVal} onChange={handleSearchFunction} />
                  </SearchSection>
                  <FilterWrapper>
                    <img
                      src={FilterIcon}
                      alt=""
                      onClick={() => setFilterPopUpModal(true)}
                    />
                  </FilterWrapper>
                </div>
              </OrderTopHeader>
              <Description>
                <AppBar position="static" className={classes.AppBar}>
                  <Tabs
                    value={value}
                    onChange={() => { }}
                    aria-label="simple tabs example"
                    variant={"scrollable"}
                    scrollButtons={"on"}
                  >
                    {tabLabels.map((label, index) => (
                      <Tab
                        key={index}
                        className={index === 0 && !storedData?.data?.isEnablePickupFeature ? classes.hiddenTab : ''}
                        label={<>{label}{showOrderCountFunction(index)}</>}
                        {...a11yProps(index)}
                        onClick={() => switchTabAndFetchData(index)}
                      />
                    ))}
                  </Tabs>
                </AppBar>
                {tabPanels.map((pageType, index) => (
                  <TabPanel key={index} value={value} index={index}>
                    {pageData && (
                      <TabContents
                        pageData={pageData}
                        pageType={pageType}
                        fetchDataCallBack={fetchPageDataFunction}
                        switchTabAndFetchData={switchTabAndFetchData}
                      />
                    )}
                  </TabPanel>
                ))}
              </Description>
            </div>
          </SectionWrapper>
        </div>

        {totalPages > 0 && (
          <Pagination
            currentPage={currentPage}
            totalPage={totalPages}
            itemsCountPerPage={10}
            onPageChange={(value) => onPageChange(value)}
          />
        )}
      </Container>

      <AlertModal
        isOpen={modal}
        toggle={() => setModal(!modal)}
        title=''
        content={modalContent}
      />

      <FilterModal
        isOpen={filterPopUpModal}
        toggle={setFilterPopUpModal}
        fieldValues={filterModalValues}
        currentTabValue={value}
        closeModal={() => setFilterPopUpModal(false)}
        callBackFun={(values) => {
          setCurrentPage(1)
          setSearchVal('')
          setFilterModalValues(values)
          setFilterPopUpModal(false)
          fetchPageDataFunction(undefined, undefined, { filterValues: values, currentPage: 1, searchValue: '' })
        }}
      />
    </section>
  );
}
